import type { auth } from "@/lib/auth"; // Import the auth instance as a type
import { adminClient, customSessionClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { useTranslations } from "next-intl"; // Import useTranslations

// Define a type for the valid error code keys
export type AuthErrorCode =
  | "USER_NOT_FOUND"
  | "FAILED_TO_CREATE_USER"
  | "FAILED_TO_CREATE_SESSION"
  | "FAILED_TO_UPDATE_USER"
  | "FAILED_TO_GET_SESSION"
  | "INVALID_PASSWORD"
  | "INVALID_EMAIL"
  | "INVALID_EMAIL_OR_PASSWORD"
  | "SOCIAL_ACCOUNT_ALREADY_LINKED"
  | "PROVIDER_NOT_FOUND"
  | "INVALID_TOKEN"
  | "ID_TOKEN_NOT_SUPPORTED"
  | "FAILED_TO_GET_USER_INFO"
  | "USER_EMAIL_NOT_FOUND"
  | "EMAIL_NOT_VERIFIED"
  | "PASSWORD_TOO_SHORT"
  | "PASSWORD_TOO_LONG"
  | "USER_ALREADY_EXISTS"
  | "EMAIL_CAN_NOT_BE_UPDATED"
  | "CREDENTIAL_ACCOUNT_NOT_FOUND"
  | "SESSION_EXPIRED"
  | "FAILED_TO_UNLINK_LAST_ACCOUNT"
  | "ACCOUNT_NOT_FOUND";

export const authClient = createAuthClient({
  baseURL: process.env.BETTER_AUTH_URL,
  plugins: [adminClient(), customSessionClient<typeof auth>()],
});

console.log(authClient.$ERROR_CODES);

export const {
  signIn,
  signOut,
  signUp,
  useSession,
  sendVerificationEmail,
  getSession,
} = authClient;

export const useLocalErrorDescription = () => {
  const t = useTranslations("Auth");

  const getLocalErrorDescription = (errorCode: string): string => {
    try {
      return t(`ErrorCodes.${errorCode}`);
    } catch {
      console.warn(
        `Translation not found for error code: ${errorCode}. Returning the code itself.`
      );
      return errorCode;
    }
  };

  return { getLocalErrorDescription };
};
